import CandidatePickerItemPresenter from './item/candidatePickerItemPresenter';

export default class CandidatesPickerPresenter {
  constructor(readonly candidatePickerItems: CandidatePickerItemPresenter[]) {}
}
